<template>
    <div id="voicepartbg" class="voicepartbg">
        <div class="voicebganimate">
            <BodyMovin
                :src="`https://p3.udn.com.tw/wish/animation/line/data_${selectSrc_3('mob', 'pad', 'pc')}.json`"
                name="voicebganimate"
                :acitve="isactive"
                :loop_flag="true"
                :autoplay_flag="true"
            />
        </div>
        <div class="maintext">
            {{who}}希望未來的台灣...
        </div>
        <div class="audiopart" @mouseover="cursorover()" @mouseleave="cursorleave()">
            <div id="buttonblur" class="buttonblur">
            </div>
            <div :class="{voicebutton:true, buttonmore:buttonflag}">
                <img v-if="isPlay" src="https://p3.udn.com.tw/wish/images/common/botton_voice_play.svg" />
                <img v-else src="https://p3.udn.com.tw/wish/images/common/botton_voice_stop.svg" />
            </div>
            <svg id="svg" width="200" height="200" viewPort="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg" @click="audioclick">
                <circle v-if="getwidth<768" id="bar" r="42.5" cx="100" cy="100" fill="transparent" stroke-dasharray="267.0435" stroke-dashoffset="267.035"></circle>
                <circle v-else id="bar" r="50" cx="100" cy="100" fill="transparent" stroke-dasharray="314.16" stroke-dashoffset="314.16"></circle>
            </svg>
        </div>
        <div class="subtitlepart">
            <BodyMovin
                :src="`https://p3.udn.com.tw/wish/animation/subtitle/${this.$store.state.currentwisher}.json`"
                name="voicesubtitle"
                :acitve="isPlay"
                :loop_flag="false"
                :autoplay_flag="false"
                :subtitle_flag="subtitleflag"
            />
        </div>
    </div>
</template>

<script>
    import { sendGaMethods } from '@/assets/js/utils/masterBuilder.js';
    import {selectSrcMethod_3} from "@/assets/js/utils/masterBuilder.js";
    import cardlistdata from '@/assets/js/data/cardlistdata'
    import BodyMovin from '@/components/common/bodymovin.vue';
    export default {
        mixins: [selectSrcMethod_3, sendGaMethods],
        data(){
            return{
                isPlay:false,
                cardlistdata,
                who: "",
                isactive: true,
                subtitleflag: false,
                buttonflag: false
            }
        },
        props: {

        },
        computed:{
            getpath(){
                return 180*Math.PI;
            },
            getwidth(){
                return window.innerWidth
            }
        },
        created () {
            window.addEventListener('load', this.loadevent);
        },
        destroyed () {
            window.removeEventListener('load', this.loadevent);
        },
        mounted(){
            this.cardlistdata.forEach(element => {
                element['cardinfo'].forEach(cell => {
                    if(cell["site_name"]==this.$store.state.currentwisher){
                        this.who=cell['name'];
                    }
                })
            });

            this.theSound = new Audio('https://p3.udn.com.tw/wish/audio/'+this.$store.state.currentwisher+'.mp3');
            this.theSound.ontimeupdate = e => {
                let percent = Math.ceil((e.target.currentTime / e.target.duration) * 100);
                let c=0;
                if(window.innerWidth<768) c = 85*Math.PI;
                else c = 100*Math.PI;
                if (percent < 0) { percent = 0;}
                if (percent > 100) { percent = 100;}
                document.getElementById("bar").style.strokeDashoffset=((100-percent)/100)*c;


                if(e.target.currentTime==e.target.duration) this.isPlay=false;
                else if(e.target.currentTime==0){
                    document.getElementById("bar").style.transition="none";
                    if(window.innerWidth<768) document.getElementById("bar").style.strokeDashoffset=85*Math.PI;
                    else document.getElementById("bar").style.strokeDashoffset=100*Math.PI;
                    this.subtitleflag=true;
                }
                else{
                    document.getElementById("bar").style.transition="stroke-dashoffset 0.25s";
                    this.subtitleflag=false;
                }
            }
        },
        components: {
            BodyMovin
        },
        methods:{
            loadevent(){
                
            },
            audioclick(){
                document.getElementById("buttonblur").style.animation='none';
                this.isactive=false;
                this.isPlay = !this.isPlay;
                if(this.isPlay){
                    this.theSound.play();
                    this.sendGA({category: 'voice', action: 'click', label: "click_voice_"+this.$store.state.currentwisher});
                }
                else this.theSound.pause();
            },
            cursorover(){
                this.buttonflag=true;
            },
            cursorleave(){
                this.buttonflag=false;
            }
        },
    }
</script>

<style lang="scss" scoped>
.voicepartbg{
    position: relative;
    background-color: #1D1C1B;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 80px;
    // @media (min-width: 768px) AND (max-width: 960px) {
    //     padding-bottom: 170px;
    // }
    // @media (min-width: 960px) {
    //     padding-bottom: 231px;
    // }
    .voicebganimate{
        position: absolute;
        width: 100%;
        height: 100%;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .maintext{
        position: relative;
        width: 100%;
        padding-top: 100px;
        text-align: center;
        font-size: 20px;
        line-height: 30px;
        font-weight: bold;
        font-family: 'Noto Serif TC';
        color: #A08E33;
        @media (min-width: 768px) AND (max-width: 960px) {
            font-size: 24px;
            line-height: 34px;
            padding-top: 120px;
        }
        @media (min-width: 960px) {
            font-size: 24px;
            line-height: 34px;
            padding-top: 147px;
        }
    }
    .audiopart{
        position: relative;
        width: 200px;
        height: 200px;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        .buttonblur{
            position: absolute;
            width: 120px;
            height: 120px;
            border-radius: 50%;
            background: transparent linear-gradient(218deg, var(--unnamed-color-a08e33) 0%, var(--unnamed-color-967727) 100%) 0% 0% no-repeat padding-box;
            background: transparent linear-gradient(218deg, #A08E33 0%, #967727 100%) 0% 0% no-repeat padding-box;
            box-shadow: 0px 0px 20px #A08E3366;
            opacity: 0.4;
            filter: blur(20px);
            animation: circle_animation 2s; 
            animation-iteration-count: infinite;
            animation-timing-function: ease-in-out;
        }
        .voicebutton{
            position: absolute;
            width: 140px;
            height: 140px;
            display: flex;
            justify-content: center;
            align-items: center;
            @media (min-width: 768px) {
                width: 160px;
                height: 160px;
            }
            img{
                width: 100%;
                height: 100%;
            }
        }
        .buttonmore{
            opacity: 0.8;
        }
        #svg{
            transform: rotate(-90deg);
        }
        #svg circle {
            transition: stroke-dashoffset 0.3s;
            stroke-width: 2px; 
            cursor: pointer;
        }
        #svg #bar {
            stroke: #E1E1E1;
        }
    }
    .subtitlepart{
        position: relative;
        width: 100%;
        max-width: 360px;
        margin: auto;
    }
}
@keyframes circle_animation {
  0% { width: 120px; height: 120px; }
  50% { width: 150px; height: 150px; }
  100% { width: 120px; height: 120px; }
}
</style>